
import './App.css';
import Home from './components/Home/Home';
import Questions from './components/Questions/Questions';

function App() {
  return (
    <div >
      <Home></Home>
      <div className='my-20'>
        <Questions></Questions>
      </div>
    </div>
  );
}

export default App;
